(async () => {
  function showGroupOrderBanner() {
    if (!document.getElementById("group-order-banner")) {
      document.querySelector("header").insertAdjacentHTML("beforeBegin",`<div id="group-order-banner" style="text-align: center;z-index:99;width: 100%;background: #ce9f2b;padding: 3px;text-align: white;color: white;">All Group Orders will be shipped to the initiator. For delivery inquires please contact your Group Order initiator. <span onclick="cancelGroupOrderWithPrompt()" style="text-decoration:underline;cursor:pointer;">Click to cancel.</span></div>`);
    }
  }

  var urlParams = new URLSearchParams(window.location.search);
  var newGroupOrderId = urlParams.get('group_order_id');
  var responseFromCart = await fetch('/cart.js');
  var cartData = await responseFromCart.json();
  var groupOrderIdFromCartAttributes = cartData.attributes['Group Order ID'] || '';

  if (newGroupOrderId) {
    try {
      // intialize group order id on cart session
      fetch("https://scout-canada-shopify-api.herokuapp.com/group-order/get-status", {
        method: "POST",
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          groupOrderId: newGroupOrderId
        })
      })
      .then((response) => response.json())
      .then((data) => {
        if (data && data.status == 'on hold') {
          fetch("/cart/update.js", {
            body: JSON.stringify({ attributes: { 'Group Order ID': newGroupOrderId } }),
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            }
          });
          showGroupOrderBanner();
        } else {
          alert("Sorry, this group order has already been processed. Please request a new group order link.")
          if (groupOrderIdFromCartAttributes) {
            // user was attempting to use a new but already processed group order ID
            // we should remove any previous group order IDs from attributes if one is set
            fetch("/cart/update.js", {
              body: JSON.stringify({ attributes: { 'Group Order ID': '' } }),
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              }
            })
          }
        }
      });
    } catch (e) {
      alert("Sorry, there was an issue applying your group order link. Please try your group order link again.");
    }
  } else if (groupOrderIdFromCartAttributes) {
    showGroupOrderBanner();
  }
})()

function cancelGroupOrderWithPrompt() {
  if (window.confirm("Are you sure you want cancel this session as a group order?")) {
    fetch("/cart/update.js", {
      body: JSON.stringify({ attributes: { 'Group Order ID': '' } }),
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      }
    })
    .then((response) => response.json())
    .then((data) => {
      if (window.location.href.includes('group_order_id')) {
        window.location.href = window.location.origin
      } else {
        location.reload();
      }
    });
  }
}

// temporary to deprecate using localstorage
if (localStorage.getItem("group-order-id")) {
  localStorage.removeItem("group-order-id");
}